import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { of } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-shortcodes',
  styleUrls: ['./property-detail-shortcodes.component.scss'],
  templateUrl: './property-detail-shortcodes.component.html',
})
export class PropertyDetailShortcodes implements OnChanges {
  @Input() propertyId: number;

  saveStatus = 0;
  enrichedAttributes$ = of([]);

  constructor(private readonly propertyService: PropertiesService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.propertyId.currentValue) {
      this.enrichedAttributes$ = this.propertyService.getPropertyEnrichedAttributes(this.propertyId);
    }
  }

  updatePropertyEnrichedAttribute(key: string, value: string) {
    const payload = { key, value };

    this.saveStatus = 1;

    this.propertyService.updatePropertyEnrichedAttribute(this.propertyId, payload).subscribe(
      (res) => {
        this.saveStatus = 2;

        setTimeout(() => {
          this.saveStatus = 0;
        }, 2000);
      },
      () => {
        this.saveStatus = -1;
      }
    );
  }
}
